<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<a id="page06"></a>
<a id="page07"></a>
<p class="dedicationText">For <em class="italic">la niña de la muñeca de palo</em><br/> (the girl of the wooden doll)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4bb07e60